<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M16 3a13 13 0 1013 13A13 13 0 0016 3zm0 24a11 11 0 1111-11 11 11 0 01-11 11z"/><path d="M22.58 12.63l-3.76-.53-1.68-3.37a1.29 1.29 0 00-2.32 0l-1.71 3.4-3.83.68A1.3 1.3 0 008.61 15l2.78 2.6-.58 3.7a1.3 1.3 0 001.29 1.5 1.34 1.34 0 00.63-.16L16 20.86l3.4 1.79a1.26 1.26 0 00.61.16 1.3 1.3 0 001.27-1.54l-.69-3.77 2.73-2.65a1.3 1.3 0 00-.74-2.22zm-3.39 3.44l-.77.74.2 1.05.43 2.35-2.12-1.12-1-.5-1 .53-2 1.11.36-2.29.16-1-.77-.72L11 14.53l2.46-.43 1-.17.45-.9L16 10.88 17 13l.47.94 1 .15 2.34.33z"/></svg>